import React, { useState } from "react";
import {
  useGetSpecialCategoriesQuery,
  useCreateSpecialCategoryMutation,
  useDeleteSpecialCategoryMutation,
} from "../../libs/specialCategory/api";

export const SpecialCategoriesManager: React.FC = () => {
  const { data: categories, isLoading } = useGetSpecialCategoriesQuery();
  const [createCategory] = useCreateSpecialCategoryMutation();
  const [deleteCategory] = useDeleteSpecialCategoryMutation();
  const [newName, setNewName] = useState("");

  const handleCreate = () => {
    const trimmed = newName.trim().toUpperCase();
    if (!trimmed) return;
    createCategory({ name: trimmed });
    setNewName("");
  };

  return (
    <div className="p-4">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-white mb-4">
        Categorie Speciali (Rehab, Prehab, ecc.)
      </h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
        Queste categorie vengono usate per esercizi che non coinvolgono un
        distretto muscolare specifico (es. riabilitazione, mobilità, postura).
      </p>

      {/* Form per aggiungere */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleCreate()}
          placeholder="Nuova categoria (es. REHAB LOMBARE)"
          className="flex-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
        />
        <button
          onClick={handleCreate}
          disabled={!newName.trim()}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-blue-500 dark:hover:bg-blue-600"
        >
          Aggiungi
        </button>
      </div>

      {/* Lista categorie */}
      {isLoading ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">Caricamento...</p>
      ) : !categories?.length ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">Nessuna categoria speciale creata.</p>
      ) : (
        <div className="space-y-1">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="flex items-center justify-between bg-gray-50 dark:bg-gray-800 rounded-lg px-3 py-2"
            >
              <span className="text-sm text-gray-700 dark:text-gray-300 font-medium">
                {cat.name}
              </span>
              <button
                onClick={() => {
                  if (window.confirm(`Eliminare "${cat.name}"?`)) {
                    deleteCategory(cat.id);
                  }
                }}
                className="text-red-400 hover:text-red-600 dark:text-red-500 dark:hover:text-red-400 text-xs"
              >
                Elimina
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
